export enum BillingsPlanEntryTaxiDriverDraftContributionType {
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsPlanEntryTaxiDriverDraftContractCorrectionContributionBaseAmountExternalTaxi =
  {
    type: BillingsPlanEntryTaxiDriverDraftContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    distance: number;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverDraftContractCorrectionContributionOtherRate =
  {
    type: BillingsPlanEntryTaxiDriverDraftContributionType.CONTRACT_CORRECTION_RATE;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverDraftBonusContributionFavorableDistance =
  {
    type: BillingsPlanEntryTaxiDriverDraftContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverDraftBonusContributionOther = {
  type: BillingsPlanEntryTaxiDriverDraftContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverDraftPenaltyContributionWrongRoute = {
  type: BillingsPlanEntryTaxiDriverDraftContributionType.PENALTY_WRONG_ROUTE;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverDraftPenaltyContributionBeingLate = {
  type: BillingsPlanEntryTaxiDriverDraftContributionType.PENALTY_BEING_LATE;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverDraftPenaltyContributionIncompatibleCar =
  {
    type: BillingsPlanEntryTaxiDriverDraftContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverDraftPenaltyContributionOther = {
  type: BillingsPlanEntryTaxiDriverDraftContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverDraftContractCorrectionContribution =
  | BillingsPlanEntryTaxiDriverDraftContractCorrectionContributionBaseAmountExternalTaxi
  | BillingsPlanEntryTaxiDriverDraftContractCorrectionContributionOtherRate;

export type BillingsPlanEntryTaxiDriverDraftBonusContribution =
  | BillingsPlanEntryTaxiDriverDraftBonusContributionFavorableDistance
  | BillingsPlanEntryTaxiDriverDraftBonusContributionOther;

export type BillingsPlanEntryTaxiDriverDraftPenaltyContribution =
  | BillingsPlanEntryTaxiDriverDraftPenaltyContributionWrongRoute
  | BillingsPlanEntryTaxiDriverDraftPenaltyContributionBeingLate
  | BillingsPlanEntryTaxiDriverDraftPenaltyContributionIncompatibleCar
  | BillingsPlanEntryTaxiDriverDraftPenaltyContributionOther;

export type BillingsPlanEntryTaxiDriverDraftContribution =
  | BillingsPlanEntryTaxiDriverDraftBonusContribution
  | BillingsPlanEntryTaxiDriverDraftPenaltyContribution
  | BillingsPlanEntryTaxiDriverDraftContractCorrectionContribution;

export type BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationFleetPartner =
  {
    name: string;
  };

export type BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriverUser =
  {
    firstName: string;
    lastName: string;
  };

export type BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriverStartingAddress =
  {
    displayName: string;
  };

export type BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriver =
  {
    user: BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriverUser;
    startingAddress: BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriverStartingAddress;
  };

export type BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociation = {
  driver: BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriver;
  fleetPartner: BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationFleetPartner | null;
};

export type BillingsPlanEntryTaxiDriverDraftContract = {
  model: string;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiDriverAssociation: BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociation;
  description: string;
};

export type BillingsPlanEntryTaxiDriverDraftBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: string | null;
  checkoutEventId: string | null;
  plannedDate: string | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsPlanEntryTaxiDriverDraftPlanEntrySolvedOrderTransportingOrderCargoOrder =
  {
    id: string;
    humanId: number;
  };

export type BillingsPlanEntryTaxiDriverDraftPlanEntrySolvedOrderTransportingOrder =
  {
    cargoOrder: BillingsPlanEntryTaxiDriverDraftPlanEntrySolvedOrderTransportingOrderCargoOrder;
  };

export type BillingsPlanEntryTaxiDriverDraftPlanEntrySolvedOrder = {
  transportingOrder: BillingsPlanEntryTaxiDriverDraftPlanEntrySolvedOrderTransportingOrder;
};

export type BillingsPlanEntryTaxiDriverDraftPlanEntry = {
  humanId: number;
  solvedOrders: BillingsPlanEntryTaxiDriverDraftPlanEntrySolvedOrder[];
};

type BillingsPlanEntryTaxiDriverDraft = {
  contract: BillingsPlanEntryTaxiDriverDraftContract;
  billingNodes: BillingsPlanEntryTaxiDriverDraftBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverDraftContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntry: BillingsPlanEntryTaxiDriverDraftPlanEntry;
  date: Date;
  passengers: string[];
  rateForDistance: number;
  correctedContractModel: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
};

export default BillingsPlanEntryTaxiDriverDraft;
